<template>
  <basic-portlet title="General Settings" :no-shadow="borderless">
    <div class="row">
      <!-- Left Side -->
      <div class="col-12 col-md-3">
        <div class="mb-4">
          <display-with-selection-modal :preselected-artwork="podcast.artwork" @selected="(ev) => { setArtwork(ev.selected_artwork)}">
            <template #label>
              <label><strong>Artwork *</strong></label>
            </template>
          </display-with-selection-modal>
          <input id="podcast_artwork"
                 v-model="podcast.artwork"
                 v-validate="'required'"
                 data-vv-scope="general-form"
                 name="Podcast Artwork"
                 class="d-none"
                 type="text">
          <p v-show="errors.has('Podcast Artwork', 'general-form')" class="help text-ss-danger">
            {{ errors.first('Podcast Artwork', 'general-form') }}
          </p>
        </div>
        <div>
          <display-with-selection-modal :preselected-artwork="podcast.banner_artwork"
                                        banner-suitable-only
                                        lock-suitability
                                        @selected="(ev) => { setBanner(ev.selected_artwork)}">
            <template #label>
              <div class="w-100 clearfix">
                <div class="float-left d-inline">
                  <label><strong>Banner Artwork</strong></label>
                </div>
                <div v-if="podcast.banner_artwork" class="float-right d-inline text-right">
                  <a href="javascript:;" @click="setBanner(null)">Remove</a>
                </div>
              </div>
            </template>
          </display-with-selection-modal>
        </div>
      </div>
      <!-- Right Side -->
      <div class="col-12 col-md-9">
        <div class="form-group">
          <label for="podcast-name"><strong>{{ getFeedLabel(true) }} Name * <span id="podcast_name_tooltip" class="ml-2 la la-question-circle" /></strong></label>
          <b-tooltip target="podcast_name_tooltip" triggers="hover">
            <div v-sanitise="tooltips.podcast_name_tooltip" />
          </b-tooltip>
          <input id="podcast-name"
                 v-model="podcast.name"
                 v-validate="'required'"
                 data-vv-scope="general-form"
                 name="Podcast Name"
                 type="text"
                 class="form-control"
                 aria-describedby="podcastNameHelp"
                 :placeholder="`${getFeedLabel(true)} Name`">

          <p v-show="errors.has('Podcast Name', 'general-form')" class="help text-ss-danger">
            {{ errors.first('Podcast Name', 'general-form') }}
          </p>

          <div v-if="podcastPropertyHasChanged('name') && podcast.uuid" class="text-ss-danger">
            Warning: Podcast name determines the URL of your podcast XML file. Do not change your podcast name without updating the URL in your syndicators.
          </div>
        </div>

        <div class="form-group">
          <label for="feed-description"><strong>Description *</strong></label>
          <!-- hidden input for validation -->
          <input v-model="podcast.description"
                 v-validate="'required'"
                 data-vv-scope="general-form"
                 type="text"
                 name="Feed Description"
                 class="d-none">
          <tip-tap v-model="podcast.description" input-id="feed-description" />
          <p v-show="errors.has('Feed Description', 'general-form')" class="help text-ss-danger">
            {{ errors.first('Feed Description', 'general-form') }}
          </p>
        </div>

        <div class="form-row">
          <div class="col-auto mr-4 mb-4">
            <label><strong>Explicit</strong></label>
            <radio-group v-model="podcast.itunes_detail.explicit"
                         group-name="explicitly"
                         :options="explicit_options" />
          </div>
          <div class="col-auto mb-4">
            <label><strong>Podcast Type <span id="podcast_type_tooltip" class="ml-2 la la-question-circle" /></strong></label>
            <b-tooltip target="podcast_type_tooltip" triggers="hover">
              <div v-sanitise="tooltips.podcast_type_tooltip" />
            </b-tooltip>
            <radio-group v-model="podcast.itunes_detail.type"
                         group-name="type"
                         :options="type_options" />
          </div>
        </div>
      </div>
    </div>
  </basic-portlet>
</template>

<script>

import { mapWritableState, mapState, mapActions } from 'pinia';
import { usePodcastManageStore } from "VueStore/app/podcastManage";
import DisplayWithSelectionModal from "VuePartials/Artwork/DisplayWithSelectionModal";
import BasicPortlet from "VueComponents/BasicPortlet";
import RadioGroup from "VueComponents/RadioGroup";
import PodcastValidateMixin from "VueMixins/PodcastValidateMixin";
import TooltipsMixin from "VueMixins/TooltipsMixin";

export default {
  components: {
    DisplayWithSelectionModal,
    BasicPortlet,
    RadioGroup,
  },
  mixins: [PodcastValidateMixin, TooltipsMixin],
  props: {
    borderless: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  computed: {
    ...mapWritableState(usePodcastManageStore, ['podcast']),
    ...mapWritableState(usePodcastManageStore, ['explicit_options']),
    ...mapWritableState(usePodcastManageStore, ['type_options']),
    ...mapState(usePodcastManageStore, ['podcastPropertyHasChanged']),
  },
  methods: {
    ...mapActions(usePodcastManageStore, ['setArtwork', 'setBanner']),
  },
};
</script>

<style lang="scss">

.ql-toolbar.ql-snow, .ql-container.ql-snow {
  border-color: rgb(226, 229, 236) !important;
}

</style>
